import { render, staticRenderFns } from "./CertificateUpload.vue?vue&type=template&id=bd415b36&scoped=true"
import script from "./CertificateUpload.vue?vue&type=script&lang=js"
export * from "./CertificateUpload.vue?vue&type=script&lang=js"
import style0 from "./CertificateUpload.vue?vue&type=style&index=0&id=bd415b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd415b36",
  null
  
)

export default component.exports